import { createFileRoute } from "@tanstack/react-router";
import HealthNetInsurance, { config } from "@/pages/HealthNetInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/health-net-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Health Net TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have Health Net insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Health Net plan in Coral.",
        },
        {
          property: "og:title",
          content: "Health Net TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have Health Net insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Health Net plan in Coral.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/health-net-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/health-net-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HealthNetInsurance />;
}
